export default {
  access: {
    refresh_token: localStorage.getItem('token') || '',
  },
  status: '',
  user: {},
};
